import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import StyledToggleButton from '../Common/StyledToggleButton';

const ClientGroupTypeButtons = ({
  setAlignment,
  alignment,
}: {
  setAlignment: React.Dispatch<React.SetStateAction<string>>;
  alignment: string;
}) => (
  <Box gap={0.5} display="flex" flexDirection="column">
    <Typography variant="meta" color="primary">
      {t('addNewClient.clientType')}
    </Typography>
    <Box gap={2} display="flex">
      <StyledToggleButton
        value="individual"
        selected={alignment === 'individual'}
        onClick={() => setAlignment('individual')}
      >
        {t('addNewClient.individual')}
      </StyledToggleButton>
      <StyledToggleButton
        value="group"
        selected={alignment === 'group'}
        onClick={() => setAlignment('group')}
      >
        {t('addNewClient.group')}
      </StyledToggleButton>
    </Box>
  </Box>
);

export default ClientGroupTypeButtons;
